// src/directive/noSpace.js

// 20260902新增注释
// // 过滤所有空白字符（包括空格、制表符、换行符等）
// const removeAllSpaces = (value) => value.replace(/\s+/g, '');

// 获取 el-input 组件内部的真实 input 元素
function getInputElement(el) {
	// el 是组件根元素（div），查找内部的 input 或 textarea
	return el.querySelector('input') || el.querySelector('textarea');
}

// 定义指令对象（Vue 3 推荐使用对象形式）
export default {
	mounted(el, binding) {
		const mode = ((binding.arg === 'trim' || binding.arg === 'leading') ? 'leading' : binding.arg) || ''; // 默认只去除开头
		const filterMap = {
			leading: (v) => v.replace(/^\s+/, ''), // 去除开头空格
			trailing: (v) => v.replace(/\s+$/, ''), // 去除尾部空格
			both: (v) => v.trim(), // 只去除首尾空格
			all: (v) => v.replace(/\s+/g, ''), // 去掉全部空格
		};
		const filterFn = filterMap[mode] || filterMap.leading;
		// 在事件处理中使用 filterFn 替代 removeAllSpaces

		// 20260901 暂时注释 去除首尾空格功能
		// const mode = binding.arg || 'all'; // 支持 只去除首尾空格（保留中间空格）v-no-space:trim 或 v-no-space:all/v-no-space（默认去掉全部空格）
		// const filterFn = mode === 'trim' ? (v) => v.trim() : (v) => v.replace(/\s+/g, '')
		// 在事件处理中使用 filterFn 替代 removeAllSpaces

		// // 20260901 暂时注释 去除首尾空格功能  20260902新增注释
		// if (mode === 'trim') {
		// 	return
		// }

		const input = getInputElement(el);
		if (!input) return;

		// 处理输入事件（实时过滤）
		const handleInput = (e) => {
			const originalValue = e.target.value;
			const filteredValue = filterFn(originalValue);
			if (originalValue !== filteredValue) {
				// 更新输入框的值，但不触发新的 input 事件（避免死循环）
				e.target.value = filteredValue;
				// 手动触发 input 事件，让 v-model 感知变化
				const event = new Event('input', {
					bubbles: true
				});
				e.target.dispatchEvent(event);
			}
		};

		// 处理粘贴事件（防止粘贴带空格）
		const handlePaste = (e) => {
			// 延迟执行，等待粘贴内容写入后过滤
			setTimeout(() => {
				const originalValue = input.value;
				const filteredValue = filterFn(originalValue);
				if (originalValue !== filteredValue) {
					input.value = filteredValue;
					input.dispatchEvent(new Event('input', {
						bubbles: true
					}));
				}
			}, 0);
		};

		// 失焦时再次清理（兜底）
		const handleBlur = () => {
			const originalValue = input.value;
			const filteredValue = filterFn(originalValue);
			if (originalValue !== filteredValue) {
				input.value = filteredValue;
				input.dispatchEvent(new Event('input', {
					bubbles: true
				}));
			}
		};

		// 保存事件监听函数，以便在 unmounted 时移除
		input._noSpaceHandlers = {
			handleInput,
			handlePaste,
			handleBlur
		};

		// 绑定事件
		input.addEventListener('input', handleInput);
		input.addEventListener('paste', handlePaste);
		input.addEventListener('blur', handleBlur);
	},

	unmounted(el) {
		const input = getInputElement(el);
		if (!input) return;
		const handlers = input._noSpaceHandlers;
		if (handlers) {
			input.removeEventListener('input', handlers.handleInput);
			input.removeEventListener('paste', handlers.handlePaste);
			input.removeEventListener('blur', handlers.handleBlur);
			delete input._noSpaceHandlers;
		}
	},
};